import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';

import styles from './connect_repo_nudge.module.css';
import memberStore from '../../stores/member.store';
import storageService from '../../services/storage.service';
import xIcon from '../../img/x.svg';
import infoIcon from '../../img/info-circle.svg';

const DISMISSED_KEY = 'nudgeCodeRepositories';

const ConnectRepoNudge = ({message}: {message: string}) => {
  const [dismissed, setDismissed] = useState(storageService.getItem<boolean>(DISMISSED_KEY, false));
  const account = memberStore.account;
  if (dismissed || !account || account.githubIntegration) return null;

  const dismiss = () => {
    storageService.setItem(DISMISSED_KEY, true);
    setDismissed(true);
  };

  return (
    <div className={styles.component}>
      <img className={styles.infoIcon} src={infoIcon} alt="info"/>
      <div className={styles.text}>
        <b>Connect your code repository</b> — {message}
      </div>
      <Link className={styles.cta} to={`/${account._id}/preferences/code-repositories`}>Connect GitHub</Link>
      <img className={styles.xIcon} src={xIcon} alt="dismiss" onClick={dismiss}/>
    </div>
  );
};

export default observer(ConnectRepoNudge);
